import React from "react";
import { Input } from "reactstrap";

const PartnerSelector = ({
  value,
  onChange,
  searchTerm,
  onSearch,
  partners,
  loading,
  loadingPartners,
  errors,
}) => {
  return (
    <>
      <Input
        id="partnerSearch"
        type="text"
        placeholder="Search partners by name..."
        value={searchTerm}
        onChange={(e) => onSearch(e.target.value)}
        disabled={loading}
        className="mb-2"
      />
      <Input
        id="partnerUuid"
        name="partnerUuid"
        type="select"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        invalid={!!errors}
        disabled={loading || loadingPartners}
        size="8"
      >
        <option value="">Select a partner...</option>
        {partners.map((partner) => (
          <option key={partner.uuid} value={partner.uuid}>
            {partner.name} ({partner.uuid})
          </option>
        ))}
      </Input>
      {loadingPartners && (
        <div className="mt-2">
          <span className="spinner-border spinner-border-sm me-2"></span>
          <small className="text-muted">Loading partners...</small>
        </div>
      )}
      {!loadingPartners && partners.length === 0 && searchTerm && (
        <small className="text-muted">No partners found matching "{searchTerm}"</small>
      )}
    </>
  );
};

export default PartnerSelector;
